import { c as _c } from "react/compiler-runtime";
import { forwardRef } from 'react';
import { styled } from '@classify/react-core-components/styles';
import Typography from '@classify/react-core-components/Typography';
const PREFIX = 'SelectableItemLabel';
const classes = {
  root: `${PREFIX}-root`
};
const StyledTypography = styled(Typography)(() => ({
  [`&.${classes.root}`]: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: 300
  }
}));
export default forwardRef((props, ref) => {
  const $ = _c(3);
  let t0;
  if ($[0] !== props || $[1] !== ref) {
    t0 = <StyledTypography component="span" className={classes.root} {...props} ref={ref} />;
    $[0] = props;
    $[1] = ref;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
});